// extracted by mini-css-extract-plugin
export default {"floatM":"index_floatM__2gERs","floatIcon":"index_floatIcon__+Q3-D","hideDisabled":"index_hideDisabled__qdXyG"};